import { createPortal, useRef } from 'preact/compat'

export const SearchHeader = ({ query, totalResults, isLoading, corrections, results }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  const resultsReady = !isLoading && Array.isArray(results?.results)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  return createPortal(
    resultsReady && (
      <div className="flex w-full flex-col gap-y-1.125" data-results={totalResults}>
        <h2 className="h2">
          {totalResults === 0 ? 'No' : 'Showing ' + totalResults} Results For "
          {corrections?.corrected ? corrections?.corrected : query}"
        </h2>
        {corrections?.corrected && (
          <div className="paragraph-s">
            <p>
              No results found for "{query}". Showing results for "{corrections.corrected}" instead.
            </p>
          </div>
        )}
        {corrections?.didYouMean && (
          <div className="paragraph-s">
            <p>
              Did you mean:{' '}
              <a
                href={`/search?query=${corrections.didYouMean}`}
                className="link-fade"
                aria-label={`Search for ${corrections.didYouMean}`}
              >
                {corrections.didYouMean}
              </a>
            </p>
          </div>
        )}
        {totalResults === 0 && (
          <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
        )}
      </div>
    ),
    searchHeader
  )
}
